export default __webpack_public_path__ + "static/media/hoppia_about_01.9f814ab5.png";